<template>
    <!-- Email input field -->
    <div :class="inputClass">
        <label
            class="input__label"
            :for="`${_uid}-input`"
            v-text="$t('COUPON_FIELD_OFFER_CODE')"/>
        <div class="container">
            <input
                :id="`${_uid}-input`"
                type="text"
                class="input__field uppercase"
                v-on:keyup.enter.prevent="validateCoupon()"
                v-model.trim="couponCode">
            <div class="coupon__input-button">
                <button
                    type="button"
                    class="btn btn--green btn--full-width"
                    @click="validateCoupon()"
                    v-html="$t('APP_COUPON_APPLY_BUTTON_TEXT')"/>
            </div>
        </div>

        <!-- Validation -->
        <p class="input__message"
           v-if="isCouponInvalid && errorHandler.has('coupon')"
           v-text="this.errorHandler.get('coupon')"/>
        <p class="input__message"
           v-if="isCouponInvalid && !this.errorHandler.has('coupon')"
           v-text="$t('COUPON_FIELD_SORRY')"/>

        <!-- success message -->
        <p class="input__message"
           v-if="!isCouponInvalid && coupon"
           v-text="coupon.successful_message"/>
    </div>
</template>

<script>
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import CouponService from '@/services/coupons/CouponService';
import { formatCouponCode } from '@/helpers/CouponHelpers';
import IncompleteRegistrationService from '@/services/users/incompleteRegistrationService/IncompleteRegistrationService';

export default {
    name: 'CouponField',
    props: {
        value: {
            default: null,
            type: String,
        },
        message: {
            required: false,
            type: String,
            default: null,
        },
        isValid: {
            default: true,
            type: Boolean,
        },
        appliedCoupon: {
            default: null,
            type: Object,
        },
        appliedCouponCode: {
            default: null,
            type: String,
        },
    },
    data() {
        return {
            couponCode: null,
            coupon: null,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    mounted() {
        let uuid = this.$globalQueryParams.uuid;
        this.couponCode = this.appliedCouponCode;
        this.coupon = this.appliedCoupon;
        uuid && !this.isEmpty && this.validateCoupon();
    },
    computed: {
        inputClass() {
            if (this.isEmpty && this.isValid === true) {
                return 'input';
            }

            return !this.isCouponInvalid ? 'input input--success' : 'input input--invalid';
        },

        isCouponInvalid() {
            return this.errorHandler.has('coupon') || !this.isValid;
        },

        isEmpty() {
            return (this.couponCode || '').length === 0;
        },
    },
    methods: {
        validateCoupon() {
            this.coupon = null;

            if (!this.isEmpty) {
                CouponService.getCouponByCouponCode(this.couponCode)
                    .then(response => {
                        this.errorHandler.reset();
                        this.coupon = response.data.properties;
                        this.$store.commit('account/setSignupCoupon', formatCouponCode(this.coupon.reference));
                        this.$store.commit('register/setFriendCode', formatCouponCode(this.coupon.reference));
                        this.$store.commit('register/setCouponCode', formatCouponCode(this.coupon.code));
                        this.$store.commit('register/setCouponProperties', response.data.properties);
                        localStorage.removeItem('urlCouponCode');
                        setTimeout(() => (new IncompleteRegistrationService()).updateOrCreate(), 0);
                        if (response.data.properties.coupon_handle) localStorage.setItem('urlCouponCode', response.data.properties.coupon_handle);
                        else if (response.data.properties.product_type.toLowerCase() === 'journey') localStorage.setItem('urlCouponCode', response.data.properties.reference);
                    })
                    .catch(error => {
                        this.errorHandler.setResponse(error.response.data);
                        this.$store.commit('register/setFriendCode', null);
                        this.$store.commit('register/setCouponCode', null);
                        this.$store.commit('register/setCouponProperties', null);
                    });
            } else {
                this.errorHandler.reset();
                this.$store.commit('register/setFriendCode', null);
                this.$store.commit('register/setCouponCode', null);
                this.$store.commit('register/setCouponProperties', null);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.container {
    display: flex;
    width: 100%;
    input {
        width: 100%;
        margin: 0 10px 0 0;
    }
}
.coupon__input-button {
    width: 100%;
}
</style>
